<template>
  <v-app>
    <v-app-bar app color="primary" dark>
      <v-app-bar-nav-icon @click="nav = !nav"></v-app-bar-nav-icon>
      <v-toolbar-title class="d-none d-sm-flex">
        Car Gerbil
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn v-if="token.length < 1" text to="/login">
        Login
      </v-btn>

      <v-btn v-if="token.length < 1" text to="/signup">
        Sign Up
      </v-btn>

      <v-btn v-if="token.length > 0" text to="/dashboard">
        Dashboard
      </v-btn>

      <v-btn v-if="token.length > 0" text @click="logOut">
        Logout
      </v-btn>
    </v-app-bar>

    <!-- Nav Drawer -->
    <v-navigation-drawer app temporary v-model="nav">
      <v-list nav>
        <v-list-item-group>
          <v-list-item v-for="item in navItems" :key="item.title" :to="item.link">
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>        
      </v-list>
    </v-navigation-drawer>

    <v-content>
      <v-slide-x-transition>
        <router-view></router-view>
      </v-slide-x-transition>
    </v-content>
  </v-app>
</template>

<script>
import rp from "request-promise-native";

export default {
  name: 'App',

  computed: {
    nav: {
      get() {
        return this.$store.state.nav;
      },
      set(val) {
        this.$store.commit("setNav", val);
      }
    },
    navItems() {
      return this.$store.state.navItems;
    },
    token() {
      return this.$store.state.token;
    }
  },

  methods: {
    async logOut() {
      // Get the vue instance            
      let self = this;          

      // Setup the options for rp
      let options = {
          method: "POST",
          uri: `${process.env.VUE_APP_HOST}/users/logoutAll`,
          auth: {
              bearer: self.$store.state.token
          },
          body: {},
          json: true
      };

      try {
          await rp(options);
          this.$store.commit("clearToken");
          this.$store.commit("logOut");
          this.$router.push("/");
      } catch (e) {
          console.log(e);
          alert(e);
      }
    }
  }
};
</script>
